import { api } from "./client.js";
import type { UnhandledSender, UnhandledListResponse, ClientFolder } from "@cas/shared";

export const unhandledApi = {
  list:    () => api.get<UnhandledListResponse>("manage/unhandled").then(r => r.entries),
  promote: (domain: string, clientDisplayName: string, folderId: string) =>
    api.post<{ folder: ClientFolder }>(`manage/unhandled/${encodeURIComponent(domain)}/promote`,
      { clientDisplayName, folderId }).then(r => r.folder),
  remove:  (domain: string) => api.del<void>(`manage/unhandled/${encodeURIComponent(domain)}`),
};
